<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-Post-21_power-structure-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-Post-21_power-structure-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.43193717277487;"
    data-aspect-ratio="0.432"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-Post-21_power-structure-xs-img"
      class="g-Post-21_power-structure-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-21_power-structure-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:10.4164%;margin-top:-6.6px;left:48.0627%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle0">Mojtaba Khamenei</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:12.2488%;margin-top:-6.6px;left:48.1459%;margin-left:-128px;width:256px;"
    >
      <p class="g-pstyle1">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:16.6882%;margin-top:-0.5px;left:75.1206%;width:66px;"
    >
      <p class="g-pstyle2">Appoints</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:20.0914%;margin-top:-0.5px;left:22.6176%;margin-left:-54px;width:108px;"
    >
      <p class="g-pstyle3">ARMED FORCES</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:20.0914%;margin-top:-0.5px;left:70.699%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle3">JUDICIARY</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:23.5207%;margin-top:-14.7px;left:70.6904%;margin-left:-74.5px;width:149px;"
    >
      <p class="g-pstyle4">Includes a Supreme Court</p>
      <p class="g-pstyle4">and lower courts</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-XS g-aiAbs"
      style="top:28.1414%;left:39.3939%;margin-left:-16.6667%;width:33.3333%;"
    >
      <p class="g-pstyle5">ISLAMIC</p>
      <p class="g-pstyle5">REVOLUTIONARY</p>
      <p class="g-pstyle5">GUARD CORPS</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:38.3112%;margin-top:-3.7px;left:70.7142%;margin-left:-66.5px;width:133px;"
    >
      <p class="g-pstyle6">Guardian Council</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-XS g-aiAbs"
      style="top:38.3508%;left:14.1583%;margin-left:-9.0909%;width:18.1818%;"
    >
      <p class="g-pstyle5">REGULAR</p>
      <p class="g-pstyle5">MILITARY</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:41.1889%;margin-top:-7.7px;left:70.5759%;margin-left:-62px;width:124px;"
    >
      <p class="g-pstyle4">6 clerics and 6 jurists</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-XS g-aiAbs"
      style="top:44.1099%;right:30.3957%;width:33.3333%;"
    >
      <p class="g-pstyle7">Approves all candidates</p>
      <p class="g-pstyle7">for elected office</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-XS g-aiAbs"
      style="top:52.356%;left:74.2424%;width:23.3333%;"
    >
      <p class="g-pstyle8">
        Appoints the supreme leader and is empowered to remove a leader, though
        it has never done so.
      </p>
    </div>
    <div
      id="g-ai0-13"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:63.6123%;margin-top:-6px;left:12.0199%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle9">Advises</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-XS g-aiAbs"
      style="top:69.2408%;left:18.0059%;margin-left:-14.2424%;width:28.4848%;"
    >
      <p class="g-pstyle10">SUPREME NATIONAL</p>
      <p class="g-pstyle10">SECURITY COUNCIL</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:70.4186%;margin-top:-6px;left:71.5265%;margin-left:-59px;width:118px;"
    >
      <p class="g-pstyle11">Elected offices</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:75.3924%;margin-top:-6px;left:40.753%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle9">Appoints</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:78.6101%;margin-top:-6.6px;left:30.825%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle12">Killed</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:82.4059%;margin-top:-7.6px;left:16.3031%;margin-left:-42px;width:84px;"
    >
      <p class="g-pstyle13">Ali Larijani</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:82.4059%;margin-top:-7.6px;left:71.58%;margin-left:-69px;width:138px;"
    >
      <p class="g-pstyle14">Masoud Pezeshkian</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:84.3692%;margin-top:-7.6px;left:71.5338%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle15">President</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:84.5001%;margin-top:-7.6px;left:16.3727%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle16">Secretary</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-XS g-aiAbs"
      style="top:88.089%;left:71.6082%;margin-left:-11.6667%;width:23.3333%;"
    >
      <p class="g-pstyle17">Assembly of experts</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-XS g-aiAbs g-aiPointText"
      style="top:94.7641%;margin-top:-6px;left:71.5113%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle11">Parliament</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-Post-21_power-structure-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.86440677966102;"
    data-aspect-ratio="0.864"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-Post-21_power-structure-sm-img"
      class="g-Post-21_power-structure-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-21_power-structure-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:12.9798%;margin-top:-6.6px;left:43.6642%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle0">Mojtaba Khamenei</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:15.5222%;margin-top:-6.6px;left:43.718%;margin-left:-128px;width:256px;"
    >
      <p class="g-pstyle1">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:20.9319%;margin-top:-0.5px;left:61.1723%;width:66px;"
    >
      <p class="g-pstyle2">Appoints</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:25.8471%;margin-top:-0.5px;left:27.1641%;margin-left:-54px;width:108px;"
    >
      <p class="g-pstyle3">ARMED FORCES</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:25.8471%;margin-top:-0.5px;left:60.5637%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle3">JUDICIARY</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:27.7963%;margin-top:-6px;left:5.8326%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle4">Advises</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:30.1183%;margin-top:-14.7px;left:60.2665%;margin-left:-74.5px;width:149px;"
    >
      <p class="g-pstyle5">Includes a Supreme Court</p>
      <p class="g-pstyle5">and lower courts</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-SM g-aiAbs"
      style="top:36.4407%;left:20.1575%;margin-left:-5.8824%;width:11.7647%;"
    >
      <p class="g-pstyle6">REGULAR</p>
      <p class="g-pstyle6">MILITARY</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-SM g-aiAbs"
      style="top:36.6102%;left:39.8039%;margin-left:-10.7843%;width:21.5686%;"
    >
      <p class="g-pstyle6">ISLAMIC</p>
      <p class="g-pstyle6">REVOLUTIONARY</p>
      <p class="g-pstyle6">GUARD CORPS</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:46.3894%;margin-top:-3.7px;left:60.5568%;margin-left:-66.5px;width:133px;"
    >
      <p class="g-pstyle7">Guardian Council</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:49.7768%;margin-top:-7.7px;left:60.1922%;margin-left:-62px;width:124px;"
    >
      <p class="g-pstyle5">6 clerics and 6 jurists</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-SM g-aiAbs"
      style="top:52.7119%;left:61.5245%;width:16.8627%;"
    >
      <p class="g-pstyle8">Approves all candidates</p>
      <p class="g-pstyle8">for elected office</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-SM g-aiAbs"
      style="top:61.1864%;left:10.4902%;margin-left:-9.2157%;width:18.4314%;"
    >
      <p class="g-pstyle9">SUPREME NATIONAL</p>
      <p class="g-pstyle9">SECURITY COUNCIL</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:63.0505%;margin-top:-6px;left:60.2192%;margin-left:-59px;width:118px;"
    >
      <p class="g-pstyle10">Elected offices</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-SM g-aiAbs"
      style="top:67.4576%;left:80.909%;width:17.8431%;"
    >
      <p class="g-pstyle11">
        Appoints the supreme leader and is empowered to remove a leader, though
        it has never done so.
      </p>
    </div>
    <div
      id="g-ai1-16"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:69.251%;margin-top:-6.6px;left:20.1417%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle12">Killed</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:69.6607%;margin-top:-6px;left:33.6403%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle4">Appoints</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:78.5731%;margin-top:-7.6px;left:60.2537%;margin-left:-69px;width:138px;"
    >
      <p class="g-pstyle13">Masoud Pezeshkian</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:78.7426%;margin-top:-7.6px;left:10.1728%;margin-left:-42px;width:84px;"
    >
      <p class="g-pstyle14">Ali Larijani</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:81.1154%;margin-top:-7.6px;left:60.2238%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle15">President</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:81.4544%;margin-top:-7.6px;left:10.2178%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle16">Secretary</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-SM g-aiAbs"
      style="top:85.9322%;left:60.2721%;margin-left:-7.549%;width:15.098%;"
    >
      <p class="g-pstyle17">Assembly of experts</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-SM g-aiAbs g-aiPointText"
      style="top:94.5759%;margin-top:-6px;left:60.2093%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle10">Parliament</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-Post-21_power-structure-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.99848714069592;"
    data-aspect-ratio="0.998"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-Post-21_power-structure-md-img"
      class="g-Post-21_power-structure-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-21_power-structure-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:14.1575%;margin-top:-8.6px;left:43.5122%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle0">Mojtaba Khamenei</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:16.5781%;margin-top:-8.6px;left:43.5538%;margin-left:-128px;width:256px;"
    >
      <p class="g-pstyle1">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:23.0708%;margin-top:-0.5px;left:58.6309%;width:66px;"
    >
      <p class="g-pstyle2">Appoints</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:28.6684%;margin-top:-0.5px;left:30.229%;margin-left:-54px;width:108px;"
    >
      <p class="g-pstyle3">ARMED FORCES</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:28.6684%;margin-top:-0.5px;left:57.4015%;margin-left:-39.5px;width:79px;"
    >
      <p class="g-pstyle3">JUDICIARY</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:31.3915%;margin-top:-7.5px;left:6.1402%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle4">Advises</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:33.0859%;margin-top:-14.7px;left:57.2306%;margin-left:-74.5px;width:149px;"
    >
      <p class="g-pstyle5">Includes a Supreme Court</p>
      <p class="g-pstyle5">and lower courts</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-MD g-aiAbs"
      style="top:39.9395%;left:21.0606%;margin-left:-5.9091%;width:11.8182%;"
    >
      <p class="g-pstyle6">REGULAR</p>
      <p class="g-pstyle6">MILITARY</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-MD g-aiAbs"
      style="top:39.9395%;left:38.4595%;margin-left:-7.5758%;width:15.1515%;"
    >
      <p class="g-pstyle6">ISLAMIC</p>
      <p class="g-pstyle6">REVOLUTIONARY</p>
      <p class="g-pstyle6">GUARD CORPS</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:44.5836%;margin-top:-4.7px;left:57.0086%;margin-left:-66.5px;width:133px;"
    >
      <p class="g-pstyle7">Guardian Council</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:48.2122%;margin-top:-7.7px;left:57.1814%;margin-left:-62px;width:124px;"
    >
      <p class="g-pstyle5">6 clerics and 6 jurists</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:53.0557%;margin-top:-14.7px;left:58.6309%;width:139px;"
    >
      <p class="g-pstyle8">Approves all candidates</p>
      <p class="g-pstyle8">for elected office</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-MD g-aiAbs"
      style="top:55.9758%;left:9.5815%;margin-left:-9.1667%;width:18.3333%;"
    >
      <p class="g-pstyle6">SUPREME NATIONAL</p>
      <p class="g-pstyle6">SECURITY COUNCIL</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:58.3204%;margin-top:-7.5px;left:56.9475%;margin-left:-59px;width:118px;"
    >
      <p class="g-pstyle9">Elected offices</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:65.4434%;margin-top:-8.6px;left:18.9185%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle10">Killed</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:66.1962%;margin-top:-7.6px;left:33.5011%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle11">Appoints</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-MD g-aiAbs"
      style="top:68.6838%;left:80.0906%;width:19.0909%;"
    >
      <p class="g-pstyle12">
        Appoints the supreme leader and is empowered to remove a leader, though
        it has never done so.
      </p>
    </div>
    <div
      id="g-ai2-18"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:76.0334%;margin-top:-7.6px;left:56.9741%;margin-left:-69px;width:138px;"
    >
      <p class="g-pstyle13">Masoud Pezeshkian</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:76.4873%;margin-top:-7.6px;left:9.6789%;margin-left:-42px;width:84px;"
    >
      <p class="g-pstyle13">Ali Larijani</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:78.454%;margin-top:-7.6px;left:56.9511%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle14">President</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:78.9079%;margin-top:-7.6px;left:9.7137%;margin-left:-40px;width:80px;"
    >
      <p class="g-pstyle14">Secretary</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-MD g-aiAbs"
      style="top:84.2663%;left:56.9612%;margin-left:-7.5%;width:15%;"
    >
      <p class="g-pstyle15">Assembly of experts</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-MD g-aiAbs g-aiPointText"
      style="top:94.7893%;margin-top:-7.6px;left:56.9277%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle16">Parliament</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-Post-21_power-structure-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.07763615295481;"
    data-aspect-ratio="1.078"
    data-min-width="930"
  >
    <div
      id="g-Post-21_power-structure-lg-img"
      class="g-Post-21_power-structure-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/Post-21_power-structure-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:16.9947%;margin-top:-9.7px;left:49.2266%;margin-left:-74px;width:148px;"
    >
      <p class="g-pstyle0">Mojtaba Khamenei</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:19.3122%;margin-top:-9.7px;left:49.222%;margin-left:-144.5px;width:289px;"
    >
      <p class="g-pstyle1">Supreme Leader, Commander-in-Chief</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:25.5598%;margin-top:-9.6px;left:62.638%;width:73px;"
    >
      <p class="g-pstyle2">Appoints</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:30.89%;margin-top:-8.6px;left:37.4562%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle3">ARMED FORCES</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:30.89%;margin-top:-8.6px;left:61.5219%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle3">JUDICIARY</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:33.5552%;margin-top:-9.6px;left:16.0068%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle4">Advises</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:35.0499%;margin-top:-17.5px;left:61.3841%;margin-left:-85px;width:170px;"
    >
      <p class="g-pstyle5">Includes a Supreme Court</p>
      <p class="g-pstyle5">and lower courts</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-LG g-aiAbs"
      style="top:41.3673%;left:44.1036%;margin-left:-5.5914%;width:11.1828%;"
    >
      <p class="g-pstyle6">ISLAMIC</p>
      <p class="g-pstyle6">REVOLUTIONARY</p>
      <p class="g-pstyle6">GUARD CORPS</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-LG g-aiAbs"
      style="top:41.5991%;left:29.04%;margin-left:-3.1183%;width:6.2366%;"
    >
      <p class="g-pstyle6">REGULAR</p>
      <p class="g-pstyle6">MILITARY</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:46.1545%;margin-top:-9.3px;left:61.1725%;margin-left:-75.5px;width:151px;"
    >
      <p class="g-pstyle7">Guardian Council</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:49.6288%;margin-top:-9.3px;left:61.4109%;margin-left:-71px;width:142px;"
    >
      <p class="g-pstyle5">6 clerics and 6 jurists</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:54.1693%;margin-top:-17.5px;left:62.638%;width:158px;"
    >
      <p class="g-pstyle8">Approves all candidates</p>
      <p class="g-pstyle8">for elected office</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-LG g-aiAbs"
      style="top:56.8946%;left:19.0498%;margin-left:-6.7742%;width:13.5484%;"
    >
      <p class="g-pstyle6">SUPREME NATIONAL</p>
      <p class="g-pstyle6">SECURITY COUNCIL</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:59.3373%;margin-top:-9.1px;left:61.1438%;margin-left:-67px;width:134px;"
    >
      <p class="g-pstyle7">Elected offices</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:66.8112%;margin-top:-9.6px;left:40.3006%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle4">Appoints</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:69.3701%;margin-top:-9.7px;left:10.7084%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle9">Killed</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-LG g-aiAbs"
      style="top:74.5075%;left:81.6988%;width:14.4086%;"
    >
      <p class="g-pstyle10">
        Appoints the supreme leader and is empowered to remove a leader, though
        it has never done so.
      </p>
    </div>
    <div
      id="g-ai3-18"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:76.3226%;margin-top:-9.7px;left:61.135%;margin-left:-77px;width:154px;"
    >
      <p class="g-pstyle0">Masoud Pezeshkian</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:76.7861%;margin-top:-9.7px;left:18.8338%;margin-left:-46.5px;width:93px;"
    >
      <p class="g-pstyle0">Ali Larijani</p>
    </div>
    <div
      id="g-ai3-20"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:78.6401%;margin-top:-9.7px;left:61.1317%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle1">President</p>
    </div>
    <div
      id="g-ai3-21"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:79.1036%;margin-top:-9.7px;left:18.8385%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle1">Secretary</p>
    </div>
    <div
      id="g-ai3-22"
      class="g-LG g-aiAbs"
      style="top:84.241%;left:61.16%;margin-left:-6.6667%;width:13.3333%;"
    >
      <p class="g-pstyle11">Assembly of experts</p>
    </div>
    <div
      id="g-ai3-23"
      class="g-LG g-aiAbs g-aiPointText"
      style="top:94.2156%;margin-top:-9.1px;left:61.1466%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle7">Parliament</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-19 15:27 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-03-19 15:27 -->
<!-- ai file: Post-21_power-structure.ai -->
<style lang="scss">
  #g-Post-21_power-structure-box {
    container-type: inline-size;
    container-name: g-Post-21_power-structure-box;
  }
  #g-Post-21_power-structure-box,
  #g-Post-21_power-structure-box .g-artboard {
    margin: 0 auto;
  }
  #g-Post-21_power-structure-box p {
    margin: 0;
  }
  #g-Post-21_power-structure-box .g-aiAbs {
    position: absolute;
  }
  #g-Post-21_power-structure-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-Post-21_power-structure-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-Post-21_power-structure-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-Post-21_power-structure-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-Post-21_power-structure-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-Post-21_power-structure-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-Post-21_power-structure-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-Post-21_power-structure-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-Post-21_power-structure-lg {
        display: block !important;
      }
    }
  }
  #g-Post-21_power-structure-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-21_power-structure-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-Post-21_power-structure-xs .g-pstyle0 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle2 {
    font-weight: 300;
    line-height: 0px;
    height: 0px;
    padding-bottom: 6px;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle3 {
    font-weight: 500;
    line-height: 0px;
    height: 0px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-21_power-structure-xs .g-pstyle4 {
    font-weight: 300;
    height: 14px;
    text-align: center;
  }
  #g-Post-21_power-structure-xs .g-pstyle5 {
    font-weight: 700;
    line-height: 6px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-21_power-structure-xs .g-pstyle6 {
    font-weight: 500;
    line-height: 6px;
    height: 6px;
    padding-bottom: 6px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-xs .g-pstyle7 {
    font-weight: 300;
    padding-bottom: 6px;
    text-align: right;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle8 {
    font-weight: 300;
  }
  #g-Post-21_power-structure-xs .g-pstyle9 {
    font-weight: 300;
    line-height: 11px;
    height: 11px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle10 {
    font-weight: 700;
    line-height: 6px;
    padding-bottom: 6px;
    font-size: 9px;
    text-align: center;
  }
  #g-Post-21_power-structure-xs .g-pstyle11 {
    font-weight: 500;
    line-height: 11px;
    height: 11px;
    padding-bottom: 6px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-xs .g-pstyle12 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-Post-21_power-structure-xs .g-pstyle13 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle14 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle15 {
    font-weight: 700;
    height: 14px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle16 {
    font-weight: 700;
    height: 14px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-xs .g-pstyle17 {
    font-weight: 500;
    line-height: 11px;
    padding-bottom: 6px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-21_power-structure-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-Post-21_power-structure-sm .g-pstyle0 {
    font-weight: 400;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle2 {
    font-weight: 300;
    line-height: 0px;
    height: 0px;
    padding-bottom: 6px;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle3 {
    font-weight: 500;
    line-height: 0px;
    height: 0px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-21_power-structure-sm .g-pstyle4 {
    font-weight: 300;
    line-height: 11px;
    height: 11px;
    padding-bottom: 6px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle5 {
    font-weight: 300;
    height: 14px;
    text-align: center;
  }
  #g-Post-21_power-structure-sm .g-pstyle6 {
    font-weight: 700;
    line-height: 6px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-21_power-structure-sm .g-pstyle7 {
    font-weight: 500;
    line-height: 6px;
    height: 6px;
    padding-bottom: 6px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-sm .g-pstyle8 {
    font-weight: 300;
    padding-bottom: 6px;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle9 {
    font-weight: 700;
    line-height: 6px;
    padding-bottom: 6px;
    font-size: 9px;
    text-align: center;
  }
  #g-Post-21_power-structure-sm .g-pstyle10 {
    font-weight: 500;
    line-height: 11px;
    height: 11px;
    padding-bottom: 6px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-sm .g-pstyle11 {
    font-weight: 300;
  }
  #g-Post-21_power-structure-sm .g-pstyle12 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-Post-21_power-structure-sm .g-pstyle13 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle14 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle15 {
    font-weight: 700;
    height: 14px;
    padding-bottom: 6px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle16 {
    font-weight: 700;
    height: 14px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-sm .g-pstyle17 {
    font-weight: 500;
    line-height: 11px;
    padding-bottom: 6px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-21_power-structure-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 14px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-Post-21_power-structure-md .g-pstyle0 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-md .g-pstyle1 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-md .g-pstyle2 {
    font-weight: 300;
    line-height: 0px;
    height: 0px;
    padding-bottom: 8px;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-md .g-pstyle3 {
    font-weight: 500;
    line-height: 0px;
    height: 0px;
    padding-bottom: 6px;
    text-align: center;
  }
  #g-Post-21_power-structure-md .g-pstyle4 {
    font-weight: 300;
    height: 14px;
    padding-bottom: 7px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-md .g-pstyle5 {
    font-weight: 300;
    height: 14px;
    text-align: center;
  }
  #g-Post-21_power-structure-md .g-pstyle6 {
    font-weight: 700;
    line-height: 8px;
    padding-bottom: 7px;
    text-align: center;
  }
  #g-Post-21_power-structure-md .g-pstyle7 {
    font-weight: 500;
    line-height: 8px;
    height: 8px;
    padding-bottom: 7px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-md .g-pstyle8 {
    font-weight: 300;
    height: 14px;
    padding-bottom: 7px;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-md .g-pstyle9 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 7px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-md .g-pstyle10 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    padding-bottom: 8px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-Post-21_power-structure-md .g-pstyle11 {
    font-weight: 300;
    height: 14px;
    padding-bottom: 7px;
    font-size: 11px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-md .g-pstyle12 {
    font-weight: 300;
  }
  #g-Post-21_power-structure-md .g-pstyle13 {
    font-weight: 400;
    height: 14px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-md .g-pstyle14 {
    font-weight: 700;
    height: 14px;
    padding-bottom: 7px;
    font-size: 14px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-md .g-pstyle15 {
    font-weight: 500;
    padding-bottom: 7px;
    font-size: 11px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-md .g-pstyle16 {
    font-weight: 500;
    height: 14px;
    padding-bottom: 7px;
    font-size: 11px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-Post-21_power-structure-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-Post-21_power-structure-lg .g-pstyle0 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-lg .g-pstyle1 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-lg .g-pstyle2 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-lg .g-pstyle3 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-Post-21_power-structure-lg .g-pstyle4 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-lg .g-pstyle5 {
    font-weight: 300;
    height: 17px;
    text-align: center;
  }
  #g-Post-21_power-structure-lg .g-pstyle6 {
    font-weight: 700;
    line-height: 10px;
    padding-bottom: 9px;
    font-size: 13px;
    text-align: center;
  }
  #g-Post-21_power-structure-lg .g-pstyle7 {
    font-weight: 500;
    height: 17px;
    padding-bottom: 9px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-Post-21_power-structure-lg .g-pstyle8 {
    font-weight: 300;
    height: 17px;
    padding-bottom: 9px;
    color: rgb(64, 64, 64);
  }
  #g-Post-21_power-structure-lg .g-pstyle9 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-Post-21_power-structure-lg .g-pstyle10 {
    font-weight: 300;
  }
  #g-Post-21_power-structure-lg .g-pstyle11 {
    font-weight: 500;
    padding-bottom: 9px;
    text-align: center;
    text-transform: uppercase;
  }

  /* Custom CSS */
</style>
